import { useMemo } from 'react';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import {
  FileTypeOptions,
  getModelFileExtensions,
  getSupportedFileExtensions,
  getSupportedFileTypesMessage,
} from '@/utils/validation';

/**
 * Single place the USD and scene-ingestion rollout gates reach the upload UI. Everything that lists,
 * accepts or validates file types reads its options from here, so the picker, the tooltip and the
 * Help page can never disagree with what the server will admit.
 */
export const useSupportedFileTypes = () => {
  const { isUsdIngestEnabled, isSceneIngestionEnabled } = useFeatureFlags();

  const fileTypeOptions = useMemo<FileTypeOptions>(
    () => ({ includeUsd: isUsdIngestEnabled, includeScans: isSceneIngestionEnabled }),
    [isUsdIngestEnabled, isSceneIngestionEnabled]
  );
  const allExtensions = useMemo(() => getSupportedFileExtensions(fileTypeOptions).split(', '), [fileTypeOptions]);
  const modelExtensions = useMemo(() => getModelFileExtensions(fileTypeOptions), [fileTypeOptions]);
  const supportedFileTypesMessage = useMemo(() => getSupportedFileTypesMessage(fileTypeOptions), [fileTypeOptions]);

  return { allExtensions, modelExtensions, supportedFileTypesMessage, fileTypeOptions };
};
